export const getUserColor = (userId:number) => {
  const colors = [
    '#FF4500', 
    '#FF69B4',
    '#1E90FF', 
    '#32CD32', 
    '#8A2BE2',
    '#FFD700', 
    '#DC143C', 
    '#00CED1', 
    '#FF7F50', 
    '#9932CC'  
  ];
  const index = Number(userId)  % 10;
  return colors[index];
};